module.exports = __webpack_public_path__ + "static/media/lampa2.2ecc5ed9.jpg";